var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.125 0L14.8975 1.76514L7.44873 9.21387L0 1.76514L1.77246 0L7.44873 5.67627L13.125 0Z","fill":"#33D87B"}));
}

ChevronInline.defaultProps = {"width":"15","height":"10","viewBox":"0 0 15 10","fill":"none"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
